// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_8n-0";